var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.5 8H14.5","stroke":"currentColor","strokeWidth":"2.5","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M8 1.5L8 14.5","stroke":"currentColor","strokeWidth":"2.5","strokeLinecap":"round","key":1})]);
}

PlusIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
